import { getData } from '../get-table'
import { HttpService } from '../http.service'
import { usePayrollStore } from '@/store/payroll-data'

const http = new HttpService()

export interface ImportRequest {
  countryId: string
  tableCode: string
  companyId: string
  accionId: string
  fileUrl: string
  observations: string
  import_allow_create: boolean
  import_allow_update: boolean
  import_allow_reverse: boolean
}

export async function getImportRequests(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = [
    'import_requests.country_id=:countryId'
    // 'import_requests.company_id=:companyId'
  ]
  if (search) {
    where.push(
      `CONCAT(tables.name,import_actions.name,process_status.name,import_requests.observation) ILIKE '%${search}%'`
    )
  } 
  // order by
  let modifier = []
  dataOrder !== ''
    ? (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = ['order by import_requests.updated_at desc'])
  // result
  const response: any = await getData({
    tables: ['pg_import_requests'],
    fields: [
      'tables.name as imports',
      'import_actions.name as actions',
      'process_status.name as statusProcess',
      'import_requests.file_url as url',
      'import_requests.error_file_url as errorUrl',
      'coalesce(import_requests.progress_percentage,0) as percentage',
      'import_requests.observation',
      'import_requests.updated_at',
      'import_requests.success_rows',
      'import_requests.total_rows',
      'import_requests.created_at'
    ],
    join: [
      'LEFT JOIN process_status ON import_requests.status_id=process_status.id',
      'LEFT JOIN import_actions ON import_requests.import_action_id=import_actions.id',
      'LEFT JOIN tables ON import_requests.table_id=tables.code'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getListImports(): Promise<[]> {
  const data = await getData<any>({
    tables: ['pg_tables'],
    fields: [
      'code',
      'name',
      'import_allow_create',
      'import_allow_update',
      'import_allow_reverse',
      'restrictions'
    ],
    where: ['(import_allow_create=true OR import_allow_update=true OR import_allow_reverse=true)'],
    modifier: ['ORDER BY name asc'],
    options: {
      outputFormat: 'json'
    }
  })

  const actions: any = await getListActions()
  for (const imports of data[0].results) {
    if (!imports.actions) {
      imports.actions = []
    }
    if(imports.import_allow_create) imports?.actions.push(actions[1])
    if (imports.import_allow_update) imports?.actions.push(actions[0])
    if (imports.import_allow_reverse) imports?.actions.push(actions[2])
  }

  return data[0].results
}

export async function getListActions(): Promise<[]> {
  const data = await getData<any>({
    tables: ['pg_import_actions'],
    fields: ['*'],
    modifier: ['order by name'],
    options: {
      outputFormat: 'json'
    }
  })

  return data[0].results
}

export async function getFieldsImport(
  tableId: string,
  actionId: string
): Promise<any> {
  const response: any = await http.get(`imports/fields/${tableId}/${actionId}`)

  return response?.data
}

/**
 *
 * @param configuracion importacion
 * @returns
 */
export async function configureImportRequest(
  data: ImportRequest
): Promise<any> {
  const storePayroll = usePayrollStore()

  const response: any = await http.post('imports', {
    countryId: storePayroll.payroll?.country?.id,
    tableCode: data.tableCode,
    accionId: data.accionId,
    fileUrl: data.fileUrl,
    observations: data.observations
  })

  return response?.data
}

export async function startUpImport(id: string) {
  const response: any = await http.get('imports/start-up/' + id)
  return response.data
}
